//hooks what's define in query params ?dev=true
import {useEffect} from "react";
import {Store} from "pullstate";

export const ResetPasswordStore = new Store({
    token: null,
});

const setToken = (token) => {
    ResetPasswordStore.update(s => {
        s.token = token;
    });
};
export const ResetPasswordState = {
    useState: ResetPasswordStore.useState,
    setToken,
    useToken: () => {
        return ResetPasswordStore.useState(s => s.token);
    },
    useIsReset: () => {
        return ResetPasswordStore.useState(s => s.token !== null);
    },
    useParamsToDefineToken: () => {
        useEffect(() => {
            const params = new URLSearchParams(window.location.search);
            const reset = params.get('resetPassword');
            setToken(reset);
        }, [])
    }
}
